import { IconButton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import { ICellRendererParams } from 'ag-grid-community'
import { ProgramOverviewDto } from '../../../../infrastructure/api/programs'
import { intl } from '../../../../i18n'

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const TransitionIconsCellRenderer = (
  params: ICellRendererParams<ProgramOverviewDto>
) => {
  if (!params.data) return null
  return (
    <Wrapper>
      <Tooltip
        title={intl.formatMessage({
          id: 'programList.list.transition.management',
        })}
      >
        <span>
          <IconButton size="small" disabled={true}>
            <AccountTreeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Wrapper>
  )
}
